import { useQuery } from '@tanstack/react-query'
import { LectureSansCoche } from '@/features/parcours/LectureSansCoche'
import { leconDunTag } from '@/lib/api/parcours'

/**
 * La partie de cours ouverte depuis un tag — RG-2.38, RG-3.16.
 *
 * **Une requête, et rien d'autre.** L'écran de lecture vit dans
 * {@link LectureSansCoche}, partagé avec le pont de la banque d'exercices
 * (§174) : ce fichier ne fait que dire par quelle porte on est entré.
 *
 * La route qu'il appelle **n'écrit rien** — « voir une partie de cours de cette
 * manière ne compte pas comme si l'utilisateur l'avait lue ».
 */
export function LectureDunTag({
  tag,
  economieDeDonnees = false,
  onQuitter,
}: {
  tag: { path: string; label: string; item?: string }
  economieDeDonnees?: boolean
  onQuitter: () => void
}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['lecon-du-tag', tag.path],
    queryFn: () => leconDunTag(tag.path, tag.item),
    staleTime: 10 * 60_000,
  })

  return (
    <LectureSansCoche
      lecon={data?.data}
      isLoading={isLoading}
      isError={isError}
      retour="Retour au fil"
      economieDeDonnees={economieDeDonnees}
      onQuitter={onQuitter}
    />
  )
}
